var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 18.3333C9.9 18.3333 10.6333 18.2417 11.275 18.0583C10.9083 17.6 10.5417 17.05 10.3583 16.4083C9.99167 16.5 9.53333 16.5 9.16667 16.5C5.13333 16.5 1.83333 13.2 1.83333 9.16667C1.83333 5.13333 5.13333 1.83333 9.16667 1.83333C9.9 1.83333 10.5417 1.925 11.1833 2.10833L12.65 0.641667C11.55 0.275 10.3583 0 9.16667 0C4.125 0 0 4.125 0 9.16667C0 14.2083 4.125 18.3333 9.16667 18.3333ZM4.125 8.70833L5.40833 7.425L8.25 10.2667L16.1333 2.38333L17.4167 3.66667L8.25 12.8333L4.125 8.70833ZM15.5833 11L14.4283 13.5208L11.9167 14.6667L14.4283 15.8217L15.5833 18.3333L16.7292 15.8217L19.25 14.6667L16.7292 13.5208L15.5833 11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckStar);
export default __webpack_public_path__ + "static/media/check_star.8d42dd88875b8df45ca644a47cb83833.svg";
export { ForwardRef as ReactComponent };